import { render } from "./ItemPrecarioBulkEditPopUp.vue?vue&type=template&id=0ac6f1f6&scoped=true"
import script from "./ItemPrecarioBulkEditPopUp.vue?vue&type=script&lang=js"
export * from "./ItemPrecarioBulkEditPopUp.vue?vue&type=script&lang=js"

import "./ItemPrecarioBulkEditPopUp.vue?vue&type=style&index=0&id=0ac6f1f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac6f1f6"]])

export default __exports__